const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim();
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();

export function hasSupabaseConfig(): boolean {
	return Boolean(supabaseUrl && supabaseAnonKey);
}

export function requireSupabaseConfig() {
	if (!supabaseUrl || !supabaseAnonKey) {
		throw new Error(
			"Supabase の環境変数が未設定です。VITE_SUPABASE_URL と VITE_SUPABASE_ANON_KEY を設定してください。",
		);
	}

	return { url: supabaseUrl, anonKey: supabaseAnonKey };
}

export function getAdminAuthCallbackUrl() {
	return `${window.location.origin}/auth/callback`;
}
